import { render, staticRenderFns } from "./claim-list.vue?vue&type=template&id=2ccd8cae&scoped=true&"
import script from "./claim-list.vue?vue&type=script&lang=js&"
export * from "./claim-list.vue?vue&type=script&lang=js&"
import style0 from "./claim-list.vue?vue&type=style&index=0&id=2ccd8cae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd8cae",
  null
  
)

export default component.exports